var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import buildMediaQuery from './buildMediaQuery';

var SIZES = {
  mobile: { minWidth: null, maxWidth: '15.6em' },
  mobileWide: { minWidth: '15.6em', maxWidth: '32.4em' },
  tablet: { minWidth: '32.4em', maxWidth: '49.2em' },
  desktop: { minWidth: '49.2em', maxWidth: '66em' },
  desktopLarge: { minWidth: '66em', maxWidth: null }
};

var Viewport = function (_React$Component) {
  _inherits(Viewport, _React$Component);

  function Viewport() {
    _classCallCheck(this, Viewport);

    return _possibleConstructorReturn(this, (Viewport.__proto__ || Object.getPrototypeOf(Viewport)).apply(this, arguments));
  }

  _createClass(Viewport, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          not = _props.not;

      var mediaQuery = buildMediaQuery(SIZES[size], not);

      return React.createElement(
        MediaQuery,
        { query: mediaQuery },
        this.props.children
      );
    }
  }]);

  return Viewport;
}(React.Component);

Viewport.propTypes = {
  not: PropTypes.bool,
  size: PropTypes.oneOf(['mobile', 'mobileWide', 'tablet', 'desktop', 'desktopLarge']).isRequired,
  children: PropTypes.node
};

Viewport.defaultProps = {
  not: false
};

export default Viewport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-viewport/es/Viewport.js
// module id = 541
// module chunks = 0